import isEmpty from 'lodash/isEmpty';
import { call, put, select } from 'redux-saga/effects';

import { fetchTopLevelCustomEvents } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { getErrorResponse } from 'utils/xhr';
import { ESFieldMappingDefinition } from 'modules/workflows/types';
import { actions } from '../actions';
import { WorkflowState } from '../ducks.types';
import { getTopLevelCustomEvents } from '../selectors';
import { filterCustomEvents } from './sagaUtils/customEvents';

// Used for fetching all top-level custom events
export default function* fetchTopLevelCustomEventsSaga() {
  try {
    let customEvents: WorkflowState['topLevelCustomEvents'] = yield select(getTopLevelCustomEvents);

    // only call the api if the custom events have not yet been loaded
    // otherwise, load from cache
    if (isEmpty(customEvents)) {
      const events: WorkflowState['topLevelCustomEvents'] | { fieldName: string }[] =
        yield call(fetchTopLevelCustomEvents);

      if (events?.length) {
        customEvents = filterCustomEvents(events as ESFieldMappingDefinition[]).map(
          (event) => event.fieldName,
        );
      } else {
        customEvents = events as WorkflowState['topLevelCustomEvents'];
      }
    }

    yield put(actions.fetchTopLevelCustomEventsResponse(customEvents));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.fetchTopLevelCustomEventsError(err));
    const message = 'Error fetching custom events. Please try again later.';
    yield put(addNegativeToastWithErrorId(message, 'fetchTopLevelCustomEventsSaga'));
  }
}
